<template>
  <div id='' style='' class='gPageBorder' v-loading='loading'>
    <el-form class='gForm' label-position="right" ref="form" :rules='rules' label-width="14.5%" :model='form'>
      <el-form-item :label="$t('lin_global.risk_name')" prop='name'>
        <el-input v-model="form.name" placeholder=""></el-input>
      </el-form-item>
      <el-form-item :label="$t('app_filestss')" prop='desc'>
        <el-input v-model="form.desc" placeholder=''></el-input>
      </el-form-item>

      <el-form-item style="background:#D3DCE6;height: 1px;"  prop=''>
      </el-form-item>

      <el-form-item :label="$t('app_stmgpsw')" prop=''>
        <el-row>

          <el-col :span="24">
            <el-switch
              v-model="form.ispsw"
              on-text=""
              off-text="">
            </el-switch>
            <el-input style="margin-left:8px;width: calc(100% - 61px);" v-show='form.ispsw'  v-model="form.psw" placeholder=''></el-input>
          </el-col>
        </el-row>
      </el-form-item>

      <el-form-item :label="$t('app_setcallf')" prop=''>
        <el-row>

          <el-col :span="24">
            <el-switch
              v-model="form.iscall"
              on-text=""
              off-text="">
            </el-switch>
            <span v-show='form.iscall'>
              <el-radio style="margin-left:8px;" v-model="form.callvl" label="0">{{$t('app_close')}}</el-radio>
              <el-radio v-model="form.callvl" label="1">{{$t('app_open')}}</el-radio>
            </span>
          </el-col>
        </el-row>
      </el-form-item>

      <el-form-item :label="$t('app_mapsl')" prop=''>
        <el-row>
          <el-col  :span="24">
            <el-switch
              v-model="form.ismap"
              on-text=""
              off-text="">
            </el-switch>
            <span v-show='form.ismap'>
              <el-radio style="margin-left:8px;" v-model="form.map" label="0">{{$t('app_bdmap')}}</el-radio>
              <el-radio v-model="form.map" label="1">{{'Google' + $t('app_map')}}</el-radio>
            </span>
          </el-col>
        </el-row>
      </el-form-item>

      <el-form-item :label="'API ' + $t('app_protocal')" prop=''>
        <el-row>
          <el-col  :span="24">
            <el-switch
              v-model="form.ishttp"
              on-text=""
              off-text="">
            </el-switch>
            <span v-show='form.ishttp'>
              <el-radio style="margin-left:8px;" v-model="form.http" label="0">HTTP</el-radio>
              <el-radio v-model="form.http" label="1">HTTPS</el-radio>
              <label style="margin-left: 16px;">{{$t('app_prtsltip')}}</label>
            </span>
          </el-col>
        </el-row>
      </el-form-item>

      <el-form-item :label="'Appstore ' + $t('app_param')" prop=''>
        <el-row>
          <el-col  :span="24">
            <el-switch
              v-model="form.isstore"
              on-text=""
              off-text="">            off-text="">
            </el-switch>
            <span v-show='form.isstore'>
              <label style="margin-left: 16px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;IP</label>
              <el-input style="width: 300px;margin-left:8px;" v-model='form.sip'></el-input>
              <label style="margin-left: 16px;">{{$t('app_port')}}</label>
              <el-input style="width: 200px;margin-left:8px;" v-model='form.sport'></el-input>
            </span>
          </el-col>
        </el-row>
      </el-form-item>

      <el-form-item :label="$t('app_rgsvpm')" prop=''>
        <el-row>
          <el-col  :span="24">
            <el-switch
              v-model="form.isauth"
              on-text=""
              off-text="">
            </el-switch>
            <span v-show='form.isauth'>
              <label style="margin-left: 16px;">{{$t('app_rgsvip')}}</label>
              <el-input style="width: 300px;margin-left:8px;" v-model='form.aip'></el-input>
              <label style="margin-left: 16px;">{{$t('app_port')}}</label>
              <el-input style="width: 200px;margin-left:8px;" v-model='form.aport'></el-input>
            </span>
          </el-col>
        </el-row>
      </el-form-item>

      <el-form-item :label="$t('app_bgntpm')" prop=''>
        <el-row>
          <el-col  :span="24">
            <el-switch
              v-model="form.isnotify"
              on-text=""
              off-text="">
            </el-switch>
            <span v-show='form.isnotify'>
              <label style="margin-left: 16px;">{{$t('app_bgntip')}}</label>
              <el-input style="width: 300px;margin-left:8px;" v-model='form.nip'></el-input>
              <label style="margin-left: 16px;">{{$t('app_port')}}</label>
              <el-input style="width: 200px;margin-left:8px;" v-model='form.nport'></el-input>
            </span>
          </el-col>
        </el-row>
      </el-form-item>


      <!-- <el-form-item :label="'WIFI' + $t('app_right')" prop=''>
        <el-radio v-model="form.wifi" label="1">{{$t('app_on1')}}</el-radio>
        <el-radio v-model="form.wifi" label="0">{{$t('app_off1')}}</el-radio>
      </el-form-item> -->

      <el-form-item>
        <el-button  type='' style='' @click="cancel">{{$t('app_cancel')}}</el-button>
        <el-button  type='primary' style='' @click="save('form')">{{$t('app_save')}}</el-button>
      </el-form-item>
    </el-form>

  </div>
</template>

<style>
</style>

<script>
  export default{
    data () {
      var phoneCheck = (rule, value, callback) => {
        if (!this.isLegalMobile(value)) {
          callback(new Error(this.$t('app_phoneIllegal')));
        } else {
          callback()
        }
      }
      return {
        detailId: '',
        loading: false,
        fatherList: [],
        form: {
          name: '',
          desc: '',
          ispsw: false,
          psw: '',
          iscall: false,
          callvl: '',
          ismap: false,
          map: '',
          // wifi: '1'
          ishttp: false,
          http: '',
          isauth: false,
          aip: '',
          aport: '',
          isnotify: false,
          nip: '',
          nport: '',
          isstore: false,
          sip: '',
          sport: ''
        },
        rules: {
          name: [
            { required: true, message: this.$t('app_input'), trigger: 'blur' }
          ],
          desc: [
            { required: true, message: this.$t('app_input'), trigger: 'blur' }
          ],
          psw: [
            { required: true, message: this.$t('app_input'), trigger: 'blur' }
          ],
          cfpsw: [
            { required: true, message: this.$t('app_input'), trigger: 'blur' }
          ],
        }
      }
    },
    methods: {
      getDetail () {
        this.loading = 1
        this.$tcDetail(this.detailId, (res) => {
          this.loading = 0
          if (res.status === 200) {
            // this.config = this.$getWObj().dvconfigDetail
            this.config = res.data
            this.config.param = JSON.parse(this.config.param1)
            this.fillData()
          } else {
            this.$message.error(res.message)
          }
        }, () => {
          // error
          this.loading = 0
          this.$message.error(this.$t('app_rqsError'))
        })
      },
      isLegalMobile (tel) {
        var sMobile = tel
        var regex = "^((13[0-9])|(14[5|7])|(15([0-3]|[5-9]))|(18[0,5-9]))\\d{8}$"
        var re = new RegExp(regex, 'g')
        if(!(re.test(sMobile))){
          return false
        } else {
          return true
        }
      },
      newform () {
        console.log(this.form)
        return
        this.loading = 1
        this.$addTc(this.form.psw, this.form.name, this.form.desc, this.form.map, this.form.wifi,  (res) => {
          this.loading = 0
          if (res.status === 200) {
            this.$router.go(-1)
          } else {
            this.$message.error(res.message)
          }
        }, () => {
          // error
          this.loading = 0
        })
      },
      editform () {
        // this.config.type === 0
        // 授权服务参数： ops_authIp //授权IP
        //        ops_authPort   //授权端口
        // 后台通知参数： tms_callbackIp  //后台IP
        //               tms_callbackPort//后台端口
        // isHttps //是否支持https

        this.loading = 1
        var data = this.config
        var configName = ''
        var configDesc = ''
        var param = {}
        var fm = this.form

        if (fm.iscall && fm.callvl) {
          param.callType = fm.callvl
        }
        if (fm.ispsw && fm.psw) {
          param.pwd = fm.psw
        }
        if (fm.ismap && fm.map) {
          param.mapType = fm.map
        }
        if (fm.ishttp && fm.http) {
          param.isHttps = fm.http
        }
        if (fm.isauth && fm.aip && fm.aport) {
          param.ops_authIp = fm.aip
          param.ops_authPort = fm.aport
        }
        if (fm.isnotify && fm.nip && fm.nport) {
          param.tms_callbackIp = fm.nip
          param.tms_callbackPort = fm.nport
        }
        if (fm.isstore && fm.sip && fm.sport) {
          param.appStoreIp = fm.sip
          param.appStorePort = fm.sport
        }

        if (!this.detailId) {
          this.$addTc(fm.name, fm.desc, param, (res) => {
            this.loading = 0
            if (res.status === 200) {
              this.setDetailLc(fm, param)
              this.$setWObj('sdjumpId', res.data.id)
              this.$router.go(-1)
            } else {
              this.$message.error(res.message)
            }
          }, () => {
            this.loading = 0
          })
        } else {
          this.$editTc(data.id, fm.name, fm.desc, param, (res) => {
            this.loading = 0
            if (res.status === 200) {
              this.setDetailLc(fm, param)
              this.$router.go(-1)
            } else {
              this.$message.error(res.message)
            }
          }, () => {
            this.loading = 0
          })
        }
      },
      setDetailLc (fm, param) {
        // if (this.config.isSetLc) {
        //   this.config.data.configName = fm.name
        //   this.config.data.configDesc = fm.desc
        //   this.config.data.terminalPassword = JSON.stringify(param)
        //   // this.config.data.wifiType = this.form.wifi
        //   // this.config.data.mapType = fm.map
        //   this.$setWObj('dvconfigDetail', this.config.data)
        // }
      },
      save (name) {
        this.$refs[name].validate((valid) => {
          if (valid) {
            if (this.form.iscall && !this.form.callvl) {
              this.$message(this.$t('app_inputCp'))
              return
            }
            if (!this.form.psw && this.form.ispsw) {
              this.$message(this.$t('app_inputCp'))
              return
            }
            if (!this.form.map && this.form.ismap) {
              this.$message(this.$t('app_inputCp'))
              return
            }
            if (!this.form.http && this.form.ishttp) {
              this.$message(this.$t('app_inputCp'))
              return
            }
            if ((!this.form.aip || !this.form.aport) && this.form.isauth) {
              this.$message(this.$t('app_inputCp'))
              return
            }
            if ((!this.form.nip || !this.form.nport) && this.form.isnotify) {
              this.$message(this.$t('app_inputCp'))
              return
            }
            if ((!this.form.sip || !this.form.sport) && this.form.isstore) {
              this.$message(this.$t('app_inputCp'))
              return
            }
            this.editform()
          } else {
            return false
          }
        })
      },
      cancel () {
        this.$router.go(-1)
      },
      fillData () {
        // console.log(data)
        var data = this.config
        var cfjs = JSON.parse(data.param1)
        this.form.name = data.configName
        this.form.desc = data.configDesc

        this.form.ispsw = cfjs.pwd?true:false
        this.form.psw = cfjs.pwd
        // this.form.wifi = data.wifiType
        this.form.ismap = cfjs.mapType?true:false
        this.form.map = cfjs.mapType
        this.form.iscall = cfjs.callType? true:false
        this.form.callvl = cfjs.callType
        this.form.ishttp = cfjs.isHttps?true:false
        this.form.http = cfjs.isHttps
        this.form.isauth = cfjs.ops_authIp && cfjs.ops_authPort ? true:false
        this.form.aip = cfjs.ops_authIp
        this.form.aport = cfjs.ops_authPort
        this.form.isnotify = cfjs.tms_callbackIp && cfjs.tms_callbackPort ? true:false
        this.form.nip = cfjs.tms_callbackIp
        this.form.nport = cfjs.tms_callbackPort

        this.form.isstore = cfjs.appStoreIp && cfjs.appStorePort ? true:false
        this.form.sip = cfjs.appStoreIp
        this.form.sport = cfjs.appStorePort

      }
    },
    mounted () {

      this.detailId = this.$getWObj().dvconfigEdit
      if (this.detailId) {
        // this.fillData(this.config.data)
        this.getDetail()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// edit.vue?54fa1f65